import React from 'react';
import Popup from './Popup';

import './MobileAppPromo.css';

const MobileAppPromo = props => {
	// dont display popup in app
	if (window.cordova) return null;

	return (
		<Popup className="mobilePromo" minPages={2}>
			<div className="promoImg">
				<img src="img/schools-iphone.jpg" />
			</div>
			<div className="headline">
				<span>
					<strong>Now you can carry B2Me with you wherever you go.</strong>
				</span>
				<span className="subHeading">
					B2Me is now available on the App Store and Google Play Store!
				</span>
				<div>
					<a
						href="https://apps.apple.com/au/app/b2me/id1497658323?mt=8"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							display: 'inline-block',
							overflow: 'hidden',
							background: 'url("/img/ios-badge.svg") no-repeat',
							width: '135px',
							height: '40px'
						}}
					/>
					<a
						href="https://play.google.com/store/apps/details?id=au.com.b2me&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							display: 'inline-block',
							overflow: 'hidden',
							width: '135px',
							height: '40px',
							marginLeft: '4px',
							background: 'url("/img/google-badge.svg") no-repeat'
						}}
					/>
				</div>
			</div>
		</Popup>
	);
};

export default MobileAppPromo;



// WEBPACK FOOTER //
// ./src/popups/MobileAppPromo.js